module.exports = __webpack_public_path__ + "static/img/8.79822092.png";